import React from 'react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  onRetry,
  className = ''
}) => {
  return (
    <div className={`p-4 m-6 bg-status-error text-theme-inverse rounded-lg ${className}`}>
      <div className="flex items-center justify-between">
        <span>{message}</span>
        {onRetry && (
          <button
            onClick={onRetry}
            className="bg-theme-primary text-status-error px-3 py-1 rounded text-sm font-medium hover:bg-theme-secondary transition-colors"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;